import { useMutation, useQueryClient } from "@tanstack/react-query";

import { graphqlClient } from "@/api/graphql";
import { graphql } from "@/generated/digitalnisklady.cz";

// eslint-disable-next-line lingui/no-unlocalized-strings
const archiveOfferDocument = graphql(`
  mutation ArchiveOffer($id: ID!) {
    archiveOffer(id: $id) {
      id
    }
  }
`);

const useArchiveOffer = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      graphqlClient.request(archiveOfferDocument, {
        id,
      }),
    onSuccess: () => {
      void client.invalidateQueries({
        queryKey: ["user"],
      });
    },
  });
};

export { useArchiveOffer };
